import { createContext } from 'react'

const IntegrationErrorContext = createContext()

export default IntegrationErrorContext
